import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.promise.all-settled.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-3ae530e5"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "academic-update"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("学术项目");

const _hoisted_3 = {
  style: {
    "position": "relative",
    "top": "3px"
  }
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "会议基础信息", -1));

const _hoisted_5 = {
  class: "center"
};

const _hoisted_6 = /*#__PURE__*/_createTextVNode("线上");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("线下");

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "会议推广信息", -1));

const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 设置邀约团队 ");

const _hoisted_10 = {
  class: "center"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin": "0 10px"
  }
}, "~", -1));

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "value"
}, "图片", -1));

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "value",
  style: {
    "margin-right": "10px"
  }
}, "外部链接", -1));

const _hoisted_14 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_15 = /*#__PURE__*/_createTextVNode("仅保存");

const _hoisted_16 = /*#__PURE__*/_createTextVNode("保存并发布");

const _hoisted_17 = ["src"];
import { ref, watch } from 'vue';
import { dateFormat, dateTimeFormat } from '@/config';
import { arrayRemoveRepeatByProp, jsonStringify, validImgSize } from '@/utils';
import { ElMessage } from 'element-plus';
import { updateAcademic, getAcademicProjectDetail, publishAcademic } from '@/request';
import { useRoute, useRouter } from 'vue-router';
import SetExtensionScopeModal from './component/SetExtensionScopeModal.vue';
import AddDrugsModal from './component/AddDrugsModal.vue';
export default {
  name: 'EditAcademicProject',

  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const form = ref({
      scienceName: '',
      time: '',
      lecturer: '',
      scienceTeamJson: '',
      scienceTeamCheckKeys: [],
      merchandiseJson: '',
      scienceWay: 1,
      scienceTeamText: '',
      scienceAddress: '',
      proTime: '',
      remindTime: '',
      adImageUrl: '',
      adFile: null,
      proImageUrl: '',
      proFile: null,
      materielType: '1',
      proLinkUrl: ''
    });
    const showExtensionScopeModal = ref(false);
    const showAddDrugsModal = ref(false);
    const formRef = ref();
    const showImgCoverModal = ref(false);
    const coverUrl = ref('');
    const drugsTableData = ref([]);
    const drugsTable = ref();
    const proFileList = ref([]);
    const adFileList = ref([]);
    const preUpload = ref();
    const adUpload = ref();
    const isSee = ref(false);
    const title = ref('添加学术项目'); // 设置数据范围后 格式化成后台需要的格式

    const treeDataLength = ref(0);
    const targetSupperName = ref('');

    function setScopeSuccess(scopes, treeLength) {
      console.log(scopes, treeLength);

      if (treeLength == 1) {
        treeDataLength.value = treeLength;
        targetSupperName.value = scopes[0].text;
      }

      form.value.scienceTeamText = scopes.map(i => i.id).join(',');
      form.value.scienceTeamCheckKeys = scopes.map(i => i.id);
      form.value.scienceTeamJson = jsonStringify(scopes.map(i => {
        const ids = i.id.split('-');

        if (ids.length > 1) {
          return {
            teamId: ids[0],
            structureId: ids[1]
          };
        }

        return {
          teamId: ids[0]
        };
      }));
    }

    function beforeUpload(rawFile) {
      if (!/.(xls|xlsx)$/.test(rawFile.name)) {
        ElMessage.error('上传文件必须是 xls 或 xlsx 格式的文件');
        return false;
      }

      return true;
    }

    function validTime(rule, val, cb) {
      if (val[0] === val[1]) {
        cb(new Error('项目开始时间与结束时间不能相同'));
        return;
      }

      cb();
    }

    function proFileValidator(rule, val, cb) {
      if (form.value.materielType === '1') {
        if (!form.value.proFile) {
          cb(new Error('请上传详情图'));
          return;
        }
      } else {
        if (!form.value.proLinkUrl) {
          cb(new Error('请填写外部链接'));
          return;
        }
      }

      cb();
    }

    function initEditData() {
      getAcademicProjectDetail({
        scienceId: route.query.scienceId,
        __warn: true,
        __repeat: true
      }).then(data => {
        if (data.success) {
          const {
            status,
            startTime,
            endTime,
            proStartTime,
            proEndTime,
            scienceAddress,
            scienceName,
            merchandiseListList,
            lecturer,
            remindTime,
            scienceWay,
            proImageUrl,
            adImageUrl,
            teamList,
            materielType = '1',
            proLinkUrl
          } = data.data;
          isSee.value = status !== 0;

          if (isSee.value) {
            title.value = '查看学术项目';
          }

          drugsTableData.value = merchandiseListList;
          proFileList.value = proImageUrl ? [{
            url: proImageUrl,
            name: 'xx'
          }] : [];
          adFileList.value = adImageUrl ? [{
            url: adImageUrl,
            name: 'xx'
          }] : [];
          form.value = {
            scienceName,
            startTime,
            endTime,
            scienceId: route.query.scienceId,
            scienceTeamCheckKeys: teamList.map(i => {
              if (i.structureId === 0) {
                return i.teamId + '';
              }

              return i.teamId + '-' + i.structureId;
            }),
            time: [startTime, endTime],
            lecturer,
            scienceTeamJson: jsonStringify(teamList.map(i => {
              if (i.structureId === 0) {
                return {
                  teamId: i.teamId
                };
              }

              return {
                teamId: i.teamId,
                structureId: i.structureId
              };
            })),
            merchandiseJson: '',
            scienceWay,
            scienceAddress,
            proStartTime,
            proEndTime,
            proTime: proStartTime,
            remindTime,
            adImageUrl,
            adFile: adImageUrl,
            proImageUrl,
            proFile: proImageUrl,
            materielType: String(materielType),
            proLinkUrl
          };
        }

        form.value.scienceTeamText = form.value.scienceTeamCheckKeys.join(',');
      });
    }

    if (route.query.scienceId) {
      // 如果存在id 查询详情数据回显
      initEditData();
      title.value = '编辑学术项目';
    }

    function goBack() {
      router.replace({
        name: route.query.from
      });
    }

    function save(type) {
      form.value.merchandiseJson = jsonStringify(drugsTableData.value.map(i => ({
        merchandiseId: i.prodNo,
        branchId: i.branchId
      })));

      const payload = _objectSpread({}, form.value);

      if (!form.value.remindTime) {
        delete payload.remindTime;
      }

      console.log(payload);

      if (payload.materielType == '1') {
        payload.proLinkUrl = '';
      } else {
        payload.proFile = null;
        payload.proImageUrl = '';
      }

      formRef.value.validate(e => {
        if (e) {
          let body = _objectSpread(_objectSpread({}, payload), {}, {
            startTime: form.value.time[0],
            endTime: form.value.time[1],
            proStartTime: form.value.proTime,
            proEndTime: form.value.time[0],
            __repeat: true,
            __warn: true
          });

          updateAcademic(body).then(data => {
            if (data.success) {
              if (type === 'publish') {
                publishActivity(data.data.scienceId);
                return;
              }

              ElMessage.success('操作成功!');
              goBack();
            }
          });
        }
      });
    }

    function publishActivity(scienceId) {
      publishAcademic({
        scienceId
      }).then(res => {
        if (res.success) {
          ElMessage.success('操作成功!');
          goBack();
        }
      });
    }

    function changeScienceWay() {
      form.value.scienceAddress = '';
      formRef.value.validateField('scienceAddress');
    } // 添加宣传图片


    function adUploadChange(file) {
      if (!/.(jp(e)?g|png|bmp)$/i.test(file.raw.name)) {
        ElMessage.error('上传文件必须是 jpg,jpeg,png,bmp格式的文件');
        adUpload.value.clearFiles();
        adFileList.value = [];
        return;
      }

      if (file.size / 1024 / 1024 > 0.4) {
        adUpload.value.clearFiles();
        adFileList.value = [];
        ElMessage.error('文件大小不可超过 400KB!');
        return;
      }

      Promise.allSettled([validImgSize(file.raw, 640, 500), validImgSize(file.raw, 500, 640)]).then(result => {
        if (result.some(i => i.value)) {
          form.value.adFile = file.raw; // 如果导入了二进制文件删除 原图片的url

          form.value.adImageUrl = '';
          formRef.value.validateField('adFile');
        } else {
          adUpload.value.clearFiles();
          adFileList.value = [];
          ElMessage.error('图片尺寸必须为 640 * 500 或 500 * 640 !');
        }
      });
    } // 添加详情图片


    function proUploadChange(file) {
      if (!/.(jp(e)?g|png|bmp)$/i.test(file.raw.name)) {
        ElMessage.error('上传文件必须是 jpg,jpeg,png,bmp格式的文件');
        preUpload.value.clearFiles();
        proFileList.value = [];
        return;
      } // 限制文件大小


      if (file.size / 1024 / 1024 > 0.5) {
        preUpload.value.clearFiles();
        proFileList.value = [];
        ElMessage.error('文件大小不可超过 2Mb!');
        return;
      } // validImgSize(file.raw, 1080, 1624).then((data) => {
      //   if (data) {
      //     form.value.proFile = file.raw;
      //     // 如果导入了二进制文件删除 原图片的url
      //     form.value.proImageUrl = '';
      //     formRef.value.validateField('proFile');
      //   } else {
      //     preUpload.value.clearFiles();
      //     proFileList.value = [];
      //     ElMessage.error('图片尺寸必须为 1080 * 1624 !');
      //   }
      // });


      form.value.proFile = file.raw; // 如果导入了二进制文件删除 原图片的url

      form.value.proImageUrl = '';
      formRef.value.validateField('proFile');
    } // 添加关联商品


    function addDrugsSuccess(rows) {
      drugsTableData.value = arrayRemoveRepeatByProp(drugsTableData.value.concat(rows), 'prodNo');
    } // 删除关联商品


    function delDrugs() {
      const selectRows = drugsTable.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      drugsTableData.value = drugsTableData.value.filter(i => selectRows.every(r => r.prodNo !== i.prodNo));
    } // 查看图片


    function showImgCover(uploadFile) {
      coverUrl.value = uploadFile.url;
      showImgCoverModal.value = true;
    }

    const tableOptions = {
      align: 'center',
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      columns: [{
        type: 'checkbox',
        width: '50px'
      }, {
        title: '药品编码',
        width: '200px',
        field: 'prodNo',
        showOverflow: true
      }, {
        title: '药品名称',
        width: '150px',
        field: 'prodName',
        showOverflow: true
      }, {
        title: '药品规格',
        width: '150px',
        field: 'packageUnit',
        showOverflow: true
      }, {
        title: '生产厂家',
        field: 'manufacturer',
        showOverflow: true
      }, {
        title: '批准文号',
        field: 'chuffl',
        showOverflow: true
      }]
    }; // 格式化时间 23:59:59

    function formatTimeEnd(timeStr) {
      if (!timeStr) return;
      return timeStr.split(' ')[0] + ' 23:59:59';
    }

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");

      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_InfoFilled = _resolveComponent("InfoFilled");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_tooltip = _resolveComponent("el-tooltip");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_Plus = _resolveComponent("Plus");

      const _component_el_upload = _resolveComponent("el-upload");

      const _component_el_image = _resolveComponent("el-image");

      const _component_el_alert = _resolveComponent("el-alert");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_breadcrumb, {
        separator: "/"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            link: "",
            onClick: goBack
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_3, _toDisplayString(title.value), 1)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_form, {
        model: form.value,
        ref_key: "formRef",
        ref: formRef,
        style: {
          "margin-top": "20px"
        },
        "label-width": "100px"
      }, {
        default: _withCtx(() => [_hoisted_4, _createVNode(_component_el_form_item, {
          label: "会议名称",
          prop: "scienceName",
          rules: {
            required: true,
            message: '请填写会议名称'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            maxlength: 50,
            modelValue: form.value.scienceName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.scienceName = $event),
            readonly: isSee.value,
            style: {
              "width": "400px"
            }
          }, null, 8, ["modelValue", "readonly"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "会议时间",
          prop: "time",
          rules: [{
            required: true,
            message: '请选择会议时间'
          }, {
            validator: validTime
          }]
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [!isSee.value ? (_openBlock(), _createBlock(_component_el_date_picker, {
            key: 0,
            modelValue: form.value.time,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.time = $event),
            type: "datetimerange",
            "range-separator": "至",
            "value-format": _unref(dateTimeFormat),
            "start-placeholder": "开始时间",
            "end-placeholder": "结束时间",
            style: {
              "width": "400px",
              "flex-grow": "0"
            },
            "default-time": [new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 2, 1, 23, 59, 59)]
          }, null, 8, ["modelValue", "value-format", "default-time"])) : (_openBlock(), _createBlock(_component_el_input, {
            key: 1,
            readonly: "",
            "model-value": form.value.startTime + '   至   ' + form.value.endTime
          }, null, 8, ["model-value"])), _createVNode(_component_el_tooltip, {
            content: "项目会议进行时间段",
            placement: "bottom"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              size: 22,
              style: {
                "margin-left": "10px"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_InfoFilled)]),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        }, 8, ["rules"]), _createVNode(_component_el_form_item, {
          label: "讲师",
          prop: "lecturer",
          readonly: isSee.value,
          rules: {
            required: true,
            message: '请填写讲师姓名'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            maxlength: 50,
            modelValue: form.value.lecturer,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.lecturer = $event),
            readonly: isSee.value,
            style: {
              "width": "400px"
            }
          }, null, 8, ["modelValue", "readonly"])]),
          _: 1
        }, 8, ["readonly"]), _createVNode(_component_el_form_item, {
          label: "开展方式",
          prop: "scienceWay",
          rules: {
            required: true,
            message: '请选择开展方式'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: form.value.scienceWay,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.scienceWay = $event),
            onChange: changeScienceWay,
            disabled: isSee.value
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              label: 1
            }, {
              default: _withCtx(() => [_hoisted_6]),
              _: 1
            }), _createVNode(_component_el_radio, {
              label: 2
            }, {
              default: _withCtx(() => [_hoisted_7]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue", "disabled"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "会议号/地址",
          prop: "scienceAddress",
          rules: [{
            required: true,
            message: form.value.scienceWay == 1 ? '请填写会议号' : '请填写地址'
          }, {
            pattern: form.value.scienceWay == 1 ? /^\d+$/ : /^\S+$/,
            message: form.value.scienceWay == 1 ? '请输入正确的会议号' : '请输入正确的地址'
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.value.scienceAddress,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.scienceAddress = $event),
            readonly: isSee.value,
            maxlength: 50,
            style: {
              "width": "600px"
            }
          }, null, 8, ["modelValue", "readonly"])]),
          _: 1
        }, 8, ["rules"]), _hoisted_8, _createVNode(_component_el_form_item, {
          label: "邀约团队",
          prop: "scienceTeamText",
          rules: {
            required: true,
            message: '请设置邀约团队'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[5] || (_cache[5] = $event => showExtensionScopeModal.value = true)
          }, {
            default: _withCtx(() => [_hoisted_9]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "推广时间",
          prop: "proTime",
          rules: {
            required: true,
            message: '请选择推广时间'
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [!isSee.value ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createVNode(_component_el_date_picker, {
            modelValue: form.value.proTime,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.proTime = $event),
            "value-format": _unref(dateTimeFormat),
            style: {
              "width": "200px"
            }
          }, null, 8, ["modelValue", "value-format"]), _hoisted_11, _createElementVNode("span", null, _toDisplayString(form.value.time[0]), 1)], 64)) : (_openBlock(), _createBlock(_component_el_input, {
            key: 1,
            readonly: "",
            "model-value": form.value.proStartTime + '   至   ' + form.value.proEndTime
          }, null, 8, ["model-value"])), _createVNode(_component_el_tooltip, {
            content: "业务员推广时间段",
            placement: "bottom"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              size: 22,
              style: {
                "margin-left": "10px"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_InfoFilled)]),
              _: 1
            })]),
            _: 1
          })])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "推广广告图",
          prop: "adFile",
          rules: {
            required: true,
            message: '请选择推广广告图'
          }
        }, {
          default: _withCtx(() => [!isSee.value ? (_openBlock(), _createBlock(_component_el_upload, {
            key: 0,
            ref_key: "adUpload",
            ref: adUpload,
            "list-type": "picture-card",
            "auto-upload": false,
            "file-list": adFileList.value,
            "onUpdate:file-list": _cache[7] || (_cache[7] = $event => adFileList.value = $event),
            class: _normalizeClass({
              upload: !!form.value.adFile || !!form.value.adImageUrl
            }),
            "on-change": adUploadChange,
            "on-preview": showImgCover,
            "on-remove": () => {
              form.value.adFile = null;
              form.value.adImageUrl = '';
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_component_Plus)]),
              _: 1
            })]),
            _: 1
          }, 8, ["file-list", "class", "on-remove"])) : (_openBlock(), _createBlock(_component_el_image, {
            key: 1,
            style: {
              "width": "100px",
              "height": "100px"
            },
            src: form.value.adImageUrl,
            "preview-src-list": [form.value.adImageUrl]
          }, null, 8, ["src", "preview-src-list"])), _createVNode(_component_el_alert, {
            style: {
              "margin-top": "10px"
            },
            title: "尺寸：500 * 640px 或 640 * 500px, 大小：最大400kb,  格式：jpg,jpeg,png,bmp",
            type: "warning"
          })]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "推广宣传物料/详情",
          prop: "proFile",
          class: _normalizeClass({
            upload: !!form.value.proFile || !!form.value.proImageUrl
          }),
          rules: {
            required: true,
            validator: proFileValidator,
            trigger: 'submit'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: form.value.materielType,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => form.value.materielType = $event),
            class: "radio-group"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              label: "1"
            }, {
              default: _withCtx(() => [_hoisted_12, !isSee.value ? (_openBlock(), _createBlock(_component_el_upload, {
                key: 0,
                "list-type": "picture-card",
                "auto-upload": false,
                ref_key: "preUpload",
                ref: preUpload,
                "file-list": proFileList.value,
                "onUpdate:file-list": _cache[8] || (_cache[8] = $event => proFileList.value = $event),
                "on-change": proUploadChange,
                "on-preview": showImgCover,
                "on-remove": () => {
                  form.value.proFile = null;
                  form.value.proImageUrl = '';
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_component_Plus)]),
                  _: 1
                })]),
                _: 1
              }, 8, ["file-list", "on-remove"])) : (_openBlock(), _createBlock(_component_el_image, {
                key: 1,
                style: {
                  "width": "100px",
                  "height": "100px"
                },
                src: form.value.proImageUrl,
                "preview-src-list": [form.value.proImageUrl]
              }, null, 8, ["src", "preview-src-list"]))]),
              _: 1
            }), _createVNode(_component_el_radio, {
              label: "2",
              style: {
                "margin-top": "20px"
              }
            }, {
              default: _withCtx(() => [_hoisted_13, _createVNode(_component_el_input, {
                modelValue: form.value.proLinkUrl,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => form.value.proLinkUrl = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["class", "rules"])]),
        _: 1
      }, 8, ["model"]), _createVNode(_component_el_row, {
        justify: "end"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: goBack
        }, {
          default: _withCtx(() => [_hoisted_14]),
          _: 1
        }), !isSee.value ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          onClick: save
        }, {
          default: _withCtx(() => [_hoisted_15]),
          _: 1
        })) : _createCommentVNode("", true), !isSee.value ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "primary",
          onClick: _cache[11] || (_cache[11] = $event => save('publish'))
        }, {
          default: _withCtx(() => [_hoisted_16]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(SetExtensionScopeModal, {
        modelValue: showExtensionScopeModal.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => showExtensionScopeModal.value = $event),
        defaultChecked: form.value.scienceTeamCheckKeys,
        isSee: isSee.value,
        onSuccess: setScopeSuccess
      }, null, 8, ["modelValue", "defaultChecked", "isSee"]), _createVNode(AddDrugsModal, {
        remainLen: 20 - drugsTableData.value.length,
        modelValue: showAddDrugsModal.value,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => showAddDrugsModal.value = $event),
        onSuccess: addDrugsSuccess
      }, null, 8, ["remainLen", "modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: showImgCoverModal.value,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => showImgCoverModal.value = $event),
        width: "600px"
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          "w-full": "",
          src: coverUrl.value,
          style: {
            "width": "100%"
          },
          alt: "Preview Image"
        }, null, 8, _hoisted_17)]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};